module.exports = __webpack_public_path__ + "assets/media/no_access.ff3693b6.svg";